module.exports = __webpack_public_path__ + "static/media/alcatel.acd244b7.svg";